{
  "statusOptions": {
    "all": "Tất cả",
    "unpaired": "Đang niêm yết",
    "paired": "Đang thanh toán",
    "paymentMade": "Chờ giải phóng token",
    "completed": "Giao dịch hoàn tất",
    "canceling": "Đang hủy",
    "canceled": "Giao dịch đã hủy",
    "forceCanceled": "Giao dịch đã hủy",
    "complainted": "Đang chỉnh sửa",
    "appealing": "Đang khiếu nại"
  },
  "tags": {
    "buy": {
      "all": "Tất cả",
      "unpaired": "Đang niêm yết",
      "paired": "Đang thanh toán",
      "paymentMade": "Chờ người bán giải phóng token",
      "completed": "Giao dịch hoàn tất",
      "canceling": "Người bán đang hủy",
      "canceled": "Giao dịch đã hủy",
      "forceCanceled": "Giao dịch đã hủy",
      "complainted": "Đang chỉnh sửa",
      "appealing": "Đang khiếu nại"
    },
    "sell": {
      "all": "Tất cả",
      "unpaired": "Đang niêm yết",
      "paired": "Người mua đang thanh toán",
      "paymentMade": "Chờ giải phóng token",
      "completed": "Giao dịch hoàn tất",
      "canceling": "Đang hủy",
      "requestCancel": "Đang hủy",
      "canceled": "Giao dịch đã hủy",
      "forceCanceled": "Giao dịch đã hủy",
      "complainted": "Đang chỉnh sửa",
      "appealing": "Đang khiếu nại"
    }
  },
  "fastTrack": {
    "all": "Tất cả",
    "creating": "Đang tạo",
    "awaitSettlement": "Chờ hoàn tất thanh toán",
    "adminResolving": "Đang xử lý",
    "completed": "Giao dịch hoàn tất",
    "failed": "Giao dịch thất bại",
    "timedOut": "Đã hết thời gian"
  }
}
